import InventoryManagementMenu from './InventoryManagementMenu';

export default InventoryManagementMenu;



// WEBPACK FOOTER //
// ./src/components/InventoryManagementMenu/index.jsx